import { useLayoutEffect } from 'react';
import gsap from 'gsap';
import { prefersReducedMotion } from '../utils/motion';

export default function useRiseIn(ref, { delay = 0, y = 14, duration = 0.5 } = {}) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el || prefersReducedMotion()) return undefined;
    const tween = gsap.fromTo(
      el,
      { autoAlpha: 0, y },
      {
        autoAlpha: 1,
        y: 0,
        duration,
        delay,
        ease: 'power3.out',
        clearProps: 'transform,opacity,visibility',
      }
    );
    return () => tween.kill();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}